import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cc-discover': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M83 212.1C83 220 79.8 227.6 74.1 232.8 69.2 237.2 62.5 239.2 52.2 239.2H48V185H52.2C62.5 185 68.9 186.7 74.1 191.6 79.8 196.6 83 204.2 83 212.1zM504.8 184H499.9V208.9H504.6C514.9 208.9 520.4 204.5 520.4 196.1 520.4 188.2 514.9 184 504.8 184zM576 80V432C576 458.5 554.5 480 528 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80zM428 253H473.3V239.2H444V217H472.3V203.2H444V185H473.3V171H428V253zM341.8 171L376.8 255.2H385.4L420.9 171H403.4L381.2 226.2 359.3 171H341.8zM258.8 212.6C258.8 237.2 278.7 257.2 303.4 257.2 328 257.2 348 237.3 348 212.6 348 188 328.1 168 303.4 168 278.8 168 258.8 187.9 258.8 212.6zM190.8 212.1C190.8 244.6 224.4 264.6 254.1 250.3V231.3C234.8 250.6 207.3 237.1 207.3 212.1 207.3 188.4 234 173 254.1 193.1V174.1C223.9 159.1 190.8 180.9 190.8 212.1zM156.9 240.4C149.3 240.4 143.1 236.7 139.4 229.6L129.1 239.5C146.9 265.6 185.7 257.7 185.7 228.2 185.7 215.1 180.3 209.2 162.1 202.6 152.5 199.2 149.8 196.7 149.8 192.3 149.8 183.6 164.3 178.2 174.7 189.8L183.1 179C164 161.9 133.4 170.1 133.4 193.3 133.4 204.6 138.6 210.5 153.6 216 179.3 225.1 168.3 240.4 156.9 240.4zM99.5 212.1C99.5 188 81.5 171 55.4 171H32V253H55.4C86.3 253 99.5 230.6 99.5 212.1zM122.9 171H106.9V253H122.9V171zM544 288C510.7 308.8 317.6 412.4 128 448H529C537.2 448 544 441.2 544 433V288zM544 253L518.1 218.5C530.2 216 536.8 207.9 536.8 195.3 536.8 166.8 506.5 170.9 483.9 170.9V252.9H499.9V220.1H502.1L524.3 252.9H544z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-discover.js
// module id = Q/ej
// module chunks = 144